import { Injectable } from '@angular/core';
import { HashMap } from '@ngneat/transloco';
import { NumberFormatOptions, TranslocoLocaleService } from '@ngneat/transloco-locale';
import {
  TokenizeResult,
  TranslationMarkupRendererFactory,
  TranslationMarkupTranspiler,
  TranslationMarkupTranspilerContext,
  TranspileResult
} from 'ngx-transloco-markup';
import { TRANSLOCO_CURRENCY_CONFIG } from '../transloco-config.module';
import { LocalizationStart, LocalizationTranspilerService } from './localization-transpiler.service';
import { PriceParams } from './model/price-params';

export class PriceStart extends LocalizationStart {
  constructor(override readonly paramsKey: string) {
    super(paramsKey);
  }
}

@Injectable()
export class PriceTranspiler implements TranslationMarkupTranspiler {
  constructor(
    private localizationTranspilerService: LocalizationTranspilerService,
    private readonly rendererFactory: TranslationMarkupRendererFactory,
    private translocoLocaleService: TranslocoLocaleService
  ) {}

  tokenize(translation: string, offset: number): TokenizeResult | undefined {
    return this.localizationTranspilerService.tokenize(translation, offset, 'price', (paramsKey: string) => new PriceStart(paramsKey));
  }

  transpile(start: number, context: TranslationMarkupTranspilerContext): TranspileResult | undefined {
    const createText = (translationParameters: HashMap, paramsKey: string): string => {
      const params = translationParameters[paramsKey] as PriceParams;
      const options = { ...TRANSLOCO_CURRENCY_CONFIG, currencyDisplay: params.currencyDisplay ?? 'symbol', currency: params.currency } as NumberFormatOptions;
      return this.translocoLocaleService.localizeNumber(params.price, 'currency', this.translocoLocaleService.getLocale(), options);
    };

    return this.localizationTranspilerService.transpile(
      start,
      context,
      (translationParameters: HashMap, paramsKey: string) => createText(translationParameters, paramsKey),
      this.rendererFactory,
      (token: unknown) => (token instanceof PriceStart ? token.paramsKey : undefined)
    );
  }
}
